import React from 'react';

const AudioTranscriptionIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
    <g fill="none">
      <circle cx="30" cy="30" r="30" fill={props.color || '#FF866E'} />
      <path
        fill="#000000"
        d="M34.51 18.21H23.75a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h10.76l6.83 6.83a2 2 0 0 0 3.41-1.41V12.8a2 2 0 0 0-3.41-1.41l-6.83 6.82z"
      />
      <polygon
        fill="#FFFFFF"
        points="35.75 21.21 25.75 21.21 25.75 30.21 35.75 30.21 41.75 36.21 41.75 15.21"
      />
      <rect
        width="4.5"
        height="9"
        x="26.75"
        y="21.21"
        fill={props.color || '#FF866E'}
        transform="rotate(180 29 25.71)"
      />
      <rect
        width="4.5"
        height="9"
        x="31.25"
        y="21.21"
        fill={props.color || '#FF866E'}
        opacity=".5"
        transform="rotate(180 33.5 25.71)"
      />
      <path
        fill="#FFFFFF"
        d="M40.75 17.63V33.8l-4.33-4.29-.29-.29h-9.41v-7h9.41l.29-.29 4.29-4.29.04-.01zm.96-2.4l-6 6h-10v9h10l6 6v-21z"
      />
      <rect width="18" height="3" x="13.25" y="36.21" fill="#000000" rx="1" />
      <rect width="18" height="3" x="13.25" y="42.21" fill="#000000" rx="1" />
    </g>
  </svg>
);

export default AudioTranscriptionIcon;
